import React from 'react';
import { ExamQuestion, CustomSwitch, renderRow } from 'components';
import { IExamSessionDetails } from 'components/models';

const TheoreticalQuestionsTab = ({ examSessionDetails, finalized }: IProps) => {
    const theoreticalCorrectQuestionsCount = examSessionDetails ? examSessionDetails.factualTheoreticalQuestionAnswers.filter(factual => factual.correct).length : 0;
    const theoreticalFailedQuestionsCount = examSessionDetails ? examSessionDetails.theoreticalQuestions.length - theoreticalCorrectQuestionsCount : 0;
    const theoreticalCorrectPercent = `(${(Math.round(10000.0 * theoreticalCorrectQuestionsCount / examSessionDetails.theoreticalQuestions.length) / 100)}%)`;
    const theoreticalFailedPercent = `(${(Math.round(10000.0 * theoreticalFailedQuestionsCount / examSessionDetails.theoreticalQuestions.length) / 100)}%)`;

    return (examSessionDetails.theoreticalQuestions ? (
        <div>
            {examSessionDetails.theoreticalQuestions.map((question, i) => {
                const props = {
                    question,
                    theoreticalFactual: examSessionDetails.factualTheoreticalQuestionAnswers.find(factual => factual.questionId === question.id),
                    num: i + 1,
                };

                return <ExamQuestion key={`theory-questions_${i}`} {...props} />;
            })}

            <section className="mt-5">
                {renderRow('ВСЕГО ВОПРОСОВ:', `${examSessionDetails.theoreticalQuestions.length}`)}
                {renderRow('ВЕРНЫХ ОТВЕТОВ:', `${theoreticalCorrectQuestionsCount} ${theoreticalCorrectPercent}`)}
                {renderRow('НЕВЕРНЫХ ОТВЕТОВ:', `${theoreticalFailedQuestionsCount} ${theoreticalFailedPercent}`)}
            </section>

            {finalized ? (
                <div className="mt-4">
                    <CustomSwitch
                      name="examResult"
                      value={examSessionDetails.isPassedTheory}
                      status={examSessionDetails.isPassedTheory ? 'accept' : 'reject'}
                      onClick={() => { }}
                      containerClassName="m-auto"
                    />
                    <b className="d-block text-center mt-2" style={{ fontWeight: 500 }}>
                        Теоретическая часть {`${examSessionDetails.isPassedTheory ? 'успешно сдана' : 'не сдана'}`}
                    </b>
                </div>
            ) : null}
        </div>
    ) : null);
};

export default TheoreticalQuestionsTab;

interface IProps {
    examSessionDetails: IExamSessionDetails;
    finalized: boolean;
}
